enum CartValidationCodeEnum {
    // Alphabetical
    PRODUCT_DISABLED = "PRODUCT_DISABLED",
    PRODUCT_INVALID_TYPE = "PRODUCT_INVALID_TYPE",
    PRODUCT_QUANTITY_MAX_EXCEEDED = "PRODUCT_QUANTITY_MAX_EXCEEDED",
    PRODUCT_QUANTITY_STOCK_INSUFFICIENT = "PRODUCT_QUANTITY_STOCK_INSUFFICIENT",
    PRODUCT_SUBSCRIPTION_INELIGIBLE = "PRODUCT_SUBSCRIPTION_INELIGIBLE",
    PRODUCT_UNAVAILABLE_UPSELL = "PRODUCT_UNAVAILABLE_UPSELL",
    SHIPPING_RESTRICTION = "SHIPPING_RESTRICTION",
    UNKNOWN = "UNKNOWN",
}

export default CartValidationCodeEnum;
